import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueSlideBar from 'vue-slide-bar'
import VueSlider from 'vue-slider-component'
import VueSweetalert2 from 'vue-sweetalert2'
import VueGoodWizard from 'vue-good-wizard'
import VueTimepicker from 'vue2-timepicker'
import VueMultiSelect from 'vue-simple-multi-select'
import VueTimers from 'vue-timers'
import Multiselect from 'vue-multiselect'
import Antd from 'ant-design-vue';
import store from './store'
import Lodash from 'lodash'
import Moment from 'moment'
import Snotify from 'vue-snotify'
import VCharts from 'v-charts'
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

Vue.use(BootstrapVue)
Vue.use(Vuelidate);
Vue.use(VueSweetalert2, options)
Vue.use(VueGoodWizard)
Vue.use(VueTimepicker)
Vue.use(VueMultiSelect)
Vue.component('vue-slide-bar', VueSlideBar)
Vue.component('VueSlider', VueSlider)
Vue.use(Multiselect)
Vue.use(Antd)
Vue.use(Snotify)
Vue.use(VCharts)
Vue.use(VueTimers)
Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$lodash', { value: Lodash } )
Object.defineProperty(Vue.prototype, '$moment', { value: Moment } )
new Vue({
  render: h => h(App),
  router,
  store,
  provide() {
    return {
      eventBus: new Vue()
    }
  }
}).$mount('#app')
